import { ChartLegend as Legend, ChartLegendItem as LegendItem } from './ChartLegend/ChartLegend'

export const Chart = { Legend, LegendItem }
